var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 119,
    viewBox: "0 0 120 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.625 55.7812V96.6875C104.625 100.795 101.295 104.125 97.1875 104.125H26.5312C22.4236 104.125 19.0938 100.795 19.0938 96.6875V55.7812M60 24.1719C60 16.9835 54.1727 11.1562 46.9844 11.1562C39.796 11.1562 33.9688 16.9835 33.9688 24.1719C33.9688 31.3602 39.796 37.1875 46.9844 37.1875C50.6263 37.1875 60 37.1875 60 37.1875M60 24.1719C60 27.7183 60 37.1875 60 37.1875M60 24.1719C60 16.9835 65.8273 11.1562 73.0156 11.1562C80.204 11.1562 86.0312 16.9835 86.0312 24.1719C86.0312 31.3602 80.204 37.1875 73.0156 37.1875C69.3737 37.1875 60 37.1875 60 37.1875M60 37.1875V104.125M17.2344 55.7812H106.484C109.565 55.7812 112.062 53.2838 112.062 50.2031V42.7656C112.062 39.6849 109.565 37.1875 106.484 37.1875H17.2344C14.1537 37.1875 11.6562 39.6849 11.6562 42.7656V50.2031C11.6562 53.2838 14.1537 55.7812 17.2344 55.7812Z",
    stroke: "#0F172A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.d9fea343759d2eb6d612177236135912.svg";
export { ForwardRef as ReactComponent };